import React from 'react'
import { Image } from 'react-bootstrap';
import stepLoader from '../../../assets/images/Loader-Gif.gif';
import stepCompletedIcon from '../../../assets/images/Icons/green-check-circle-fill.svg';
import '../../Shared/css/common.css';
import '../DealerSignup.css';
import '../NewOnBoarding.css'

const OnBoardingTabs = (props) => {

    const completedTabCount = localStorage.getItem('OnBoardingTab');
    const partnerDetails = localStorage.getItem('partnerDetails') ? JSON.parse(localStorage.getItem('partnerDetails')) : {};
    const getLiClass = (conditionTab) => {

        const isLender = sessionStorage.getItem('tempDealerId');
        let className = 'bold-500 content-text-14px';

        if (props.currentComponentCount === conditionTab)
            className += ' active-item white-text';

        if (isLender)
            className += ' cursor-pointer';

        return className;

    }

    return (
        <ul className='onBoardingTabsLists position-relative'>
            <li className={props.currentComponentCount === 1 ? 'active-item white-text bold-500 content-text-14px' : 'bold-500 content-text-14px'}>
                {completedTabCount >= 1 ?
                    <span className='step-icon' style={{ border: '0px', }}>
                        <Image src={stepCompletedIcon} className="step-loader" />
                    </span>
                    :
                    props.currentComponentCount === 1 ?
                        <span className='step-icon' style={{ border: '0px', }}>
                            <Image src={stepLoader} className="step-loader" />
                        </span> : <span className='step-icon'>1</span>}
                <span className={((completedTabCount < 1) && (!props.currentComponentCount == 1)) ? 'secondary-text-color' : ''}>Dealer Sign up</span>
                <span className={((completedTabCount < 1) && (!props.currentComponentCount == 1)) ? 'secondary-text-color display-block bold-300' : 'display-block bold-300'} style={{ fontSize: '10px' }}>2 Mins</span>
            </li>
            <li className={props.currentComponentCount === 2 ? 'active-item white-text bold-500 content-text-14px' : 'bold-500 content-text-14px'}>
                {completedTabCount >= 2 ?
                    <span className='step-icon' style={{ border: '0px', }}>
                        <Image src={stepCompletedIcon} className="step-loader" />
                    </span>
                    :
                    props.currentComponentCount === 2 ?
                        <span className='step-icon' style={{ border: '0px', }}>
                            <Image src={stepLoader} className="step-loader" />
                        </span> : <span className='step-icon'>2</span>}
                <span className={(completedTabCount < 2) ? 'secondary-text-color' : (props.currentComponentCount) ? 'text-white' : ''}>Verification</span>
                <span className={(completedTabCount < 2) ? 'secondary-text-color display-block bold-300' : 'display-block bold-300'} style={{ fontSize: '10px' }}>1 Min</span>
            </li>
            <li onClick={() => props.changeTabForLender(3)} className={getLiClass(3)}>
                {completedTabCount >= 3 ?
                    <span className='step-icon' style={{ border: '0px', }}>
                        <Image src={stepCompletedIcon} className="step-loader" />
                    </span>
                    :
                    props.currentComponentCount === 3 ?
                        <span className='step-icon' style={{ border: '0px', }}>
                            <Image src={stepLoader} className="step-loader" />
                        </span> : <span className='step-icon'>3</span>}
                <span className={((completedTabCount < 3)) ? 'secondary-text-color' : ''}>Principal Information</span>
                <span className={((completedTabCount < 3)) ? 'secondary-text-color display-block bold-300' : 'display-block bold-300'} style={{ fontSize: '10px' }}>2 Mins</span>
            </li>
            {partnerDetails.enablePlaid ? 
            <li onClick={() => props.changeTabForLender(4)} className={getLiClass(4)}>
                {completedTabCount >= 4 ?
                    <span className='step-icon' style={{ border: '0px', }}>
                        <Image src={stepCompletedIcon} className="step-loader" />
                    </span>
                    :
                    props.currentComponentCount === 4 ?
                        <span className='step-icon' style={{ border: '0px', }}>
                            <Image src={stepLoader} className="step-loader" />
                        </span> : <span className='step-icon'>4</span>}
                <span className={((completedTabCount < 4)) ? 'secondary-text-color' : ''}>Financial Details</span>
                <span className={((completedTabCount < 4)) ? 'secondary-text-color display-block bold-300' : 'display-block bold-300'} style={{ fontSize: '10px' }}>1 Min</span>
            </li>: null }
            <li onClick={() => props.changeTabForLender(5)} className={getLiClass(5)}>
                {completedTabCount >= 5 ?
                    <span className='step-icon' style={{ border: '0px', }}>
                        <Image src={stepCompletedIcon} className="step-loader" />
                    </span>
                    :
                    props.currentComponentCount === 5 ?
                        <span className='step-icon' style={{ border: '0px', }}>
                            <Image src={stepLoader} className="step-loader" />
                        </span> : <span className='step-icon'>{partnerDetails.enablePlaid ? 5 : 4}</span>}
                <span className={((completedTabCount < 5)) ? 'secondary-text-color' : ''}>Dealership Info</span>
                <span style={{ fontSize: '10px' }} className={((completedTabCount < 5)) ? 'secondary-text-color display-block bold-300' : 'display-block bold-300'}>1 Min</span>
            </li>
            <li onClick={() => props.changeTabForLender(6)} className={getLiClass(6)}>
                {completedTabCount >= 6 ?
                    <span className='step-icon' style={{ border: '0px', }}>
                        <Image src={stepCompletedIcon} className="step-loader" />
                    </span>
                    :
                    props.currentComponentCount === 6 ?
                        <span className='step-icon' style={{ border: '0px', }}>
                            <Image src={stepLoader} className="step-loader" />
                        </span> : <span className='step-icon'>{partnerDetails.enablePlaid ? 6 : 5}</span>}
                <span className={((completedTabCount < 6)) ? 'secondary-text-color' : ''}>Attachments</span>
                <span className={((completedTabCount < 6)) ? 'secondary-text-color display-block bold-300' : 'display-block bold-300'} style={{ fontSize: '10px' }}>1 Min</span>
            </li>
            <li onClick={() => props.changeTabForLender(7)} className={getLiClass(7)}>
                {completedTabCount >= 7 ?
                    <span className='step-icon' style={{ border: '0px', }}>
                        <Image src={stepCompletedIcon} className="step-loader" />
                    </span>
                    :
                    props.currentComponentCount === 7 ?
                        <span className='step-icon' style={{ border: '0px', }}>
                            <Image src={stepLoader} className="step-loader" />
                        </span> : <span className='step-icon'>{partnerDetails.enablePlaid ? 7 : 6}</span>}
                <span className={((completedTabCount < 7)) ? 'secondary-text-color' : ''}>Digital Signature</span>
                <span className={((completedTabCount < 7)) ? 'secondary-text-color display-block bold-300' : 'display-block bold-300'} style={{ fontSize: '10px' }}>1 Min</span>
            </li>
        </ul >
    )
}

export default OnBoardingTabs;